import axios from 'axios';
import React, { Component } from 'react';

import spinner from '../images/spinner.svg';
import {
    TelevisionContainer,
    TelevisionContent,
    TelevisionContentWrapper,
    TelevisionLight,
    TelevisionLightContainer,
    TelevisionPicture,
    TelevisionPictureSource,
    TelevisionPoster,
    TelevisionPreloader,
} from  './styled';

const Sections = {
    sectionMain: {
        poster: '/static/images/catchup/poster-1.jpg',
    },
    sectionFunctions: {
        poster: '/static/images/catchup/poster-2.jpg',
        mp4: '/static/video/catchup/catchup-01.mp4',
        webm: '/static/video/catchup/catchup-01.webm',
    },
    sectionArchive: {
        poster: '/static/images/catchup/poster-3.jpg',
        mp4: '/static/video/catchup/catchup-02.mp4',
        webm: '/static/video/catchup/catchup-02.webm',
    },
};

export default class Television extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoaded: false,
            isLoading: false,
            isNoDynamic: false,
            isPlaying: false,
        };

        this.videoplayer = React.createRef();
    }

    getVideoSrc() {
        const { mod } = this.props;

        try {
            const videoInfo = Sections[mod];

            return (this.videoplayer.current.canPlayType('video/webm') !== '') ? videoInfo.webm : videoInfo.mp4;
        } catch (e) {
            return '';
        }
    }

    playVideo() {
        if (this.props.breakpoint === 'tablet' || this.props.breakpoint === 'phone') {
 return;
}

        if (!this.state.isLoading && this.videoplayer.current !== null && !this.state.isPlaying) {
            this.videoplayer.current.currentTime = 0;
            this.videoplayer.current.play();
            this.setState({ isPlaying: true });
        }
    }

    stopVideo() {
        if (!this.state.isLoading && this.videoplayer.current !== null && this.state.isPlaying) {
            this.videoplayer.current.pause();
            this.setState({ isPlaying: false });
        }
    }

    async loadVideo() {
        if (this.props.breakpoint === 'tablet' || this.props.breakpoint === 'phone') {
 return;
}
        if (this.state.isLoading) {
 return;
}

        const src = this.getVideoSrc();
        this.setState({ isLoading : true });

        if (src === '') {
 return;
}

        try {
            const response = await axios.get(src, {
                responseType: 'blob',
            });

            const videoUrl = URL.createObjectURL(response.data);
            this.videoplayer.current.src = videoUrl;
            this.setState({ isLoading : false, isLoaded: true });
            if (this.props.isPlay) {
                setTimeout(() => {
                    this.playVideo();
                }, 50);
            }
        } catch (e) {
            this.setState({ isLoading : false });
        }
    }

    onTimeUpdate() {
        if (this.videoplayer.current === null) {
 return;
}
        const { currentTime } = this.videoplayer.current;

        if (currentTime >= 2 && currentTime <= 6) {
            if (!this.state.isNoDynamic) {
                this.setState({ isNoDynamic: true });
            }
        } else if (this.state.isNoDynamic) {
                this.setState({ isNoDynamic: false });
            }
    }

    componentDidMount() {
        if (this.videoplayer.current !== null) {
            this.loadVideo();
            if (this.props.mod === 'sectionFunctions') {
 this.videoplayer.current.addEventListener('timeupdate', this.onTimeUpdate.bind(this));
}
        }
    }

    componentWillUnmount() {
        if (this.videoplayer.current !== null) {
            if (this.props.mod === 'sectionFunctions') {
 this.videoplayer.current.removeEventListener('timeupdate', this.onTimeUpdate.bind(this));
}
        }
    }

    componentDidUpdate({ isPlay, breakpoint }) {
        if (this.videoplayer.current === null) {
 return;
}

        if (breakpoint !== this.props.breakpoint) {
            if (this.props.breakpoint === 'tablet' || this.props.breakpoint === 'phone') {
 this.stopVideo();
} else if (!this.state.isLoaded) {
                    this.loadVideo();
                } else if (this.props.isPlay) {
                    this.playVideo();
                }
        }

        if (isPlay !== this.props.isPlay) {
            if (!this.state.isLoaded) {
                this.loadVideo();
                return;
            }

            if (!this.props.isPlay) {
                this.stopVideo();
            } else {
                this.playVideo();
            }
        }
    }

    render() {
        const { mod, onClick, ...props } = this.props;

        const isDark = (mod === 'sectionFunctions' || mod === 'sectionArchive');

        const poster = (Sections[mod] !== undefined) ? Sections[mod].poster : null;

        return (
            <TelevisionContainer {...props}>
                <TelevisionContentWrapper>
                    {(mod === 'sectionFunctions' || mod === 'sectionArchive') && (<TelevisionContent ref={this.videoplayer} muted={true} loop={true} as='video' />)}

                    {poster && (<TelevisionPoster draggable={false} onClick={onClick} as='img' isPlaying={this.state.isPlaying} src={poster} alt='Alt'/>)}

                    {this.state.isLoading && (<TelevisionPreloader src={spinner} alt='preloader' />)}
                </TelevisionContentWrapper>

                {isDark && (
                    <TelevisionPicture>
                        <source srcSet='/static/images/catchup/television-dark.webp' type='image/webp' />
                        <TelevisionPictureSource mod={mod} as='img' src='/static/images/catchup/television-dark.png' alt='television' />
                    </TelevisionPicture>)
                }

                {!isDark && (
                    <TelevisionPicture>
                        <source srcSet='/static/images/catchup/television.webp' type='image/webp' />
                        <TelevisionPictureSource mod={mod} as='img' src='/static/images/catchup/television.png' alt='television' />
                    </TelevisionPicture>)
                }

                {mod === 'sectionFunctions' && (
                    <TelevisionLightContainer>
                        <TelevisionLight isPlaying={this.state.isPlaying} isNoDynamic={this.state.isNoDynamic} src='/static/images/catchup/light-3.png' alt='televizor light' />
                        <TelevisionLight isPlaying={this.state.isPlaying} isNoDynamic={this.state.isNoDynamic} src='/static/images/catchup/light-2.png' alt='televizor light' />
                        <TelevisionLight isPlaying={this.state.isPlaying} isNoDynamic={this.state.isNoDynamic} src='/static/images/catchup/light-1.png' alt='televizor light' />
                    </TelevisionLightContainer>)
                }

                {mod === 'sectionArchive' && (
                    <TelevisionLightContainer>
                        <TelevisionLight isPlaying={this.state.isPlaying} isNoDynamic={this.state.isNoDynamic} src='/static/images/catchup/light-2.png' alt='televizor light' />
                        <TelevisionLight isPlaying={this.state.isPlaying} isNoDynamic={this.state.isNoDynamic} src='/static/images/catchup/light-1.png' alt='televizor light' />
                    </TelevisionLightContainer>)
                }
            </TelevisionContainer>
        );
    }
}
